module.exports = __webpack_public_path__ + "static/media/modern-temp.c06b6dec.jpeg";